import { render, staticRenderFns } from "./TradeMasterInvestorAccountTab.vue?vue&type=template&id=ff2fedbc&scoped=true"
import script from "./TradeMasterInvestorAccountTab.vue?vue&type=script&lang=js"
export * from "./TradeMasterInvestorAccountTab.vue?vue&type=script&lang=js"
import style0 from "./TradeMasterInvestorAccountTab.vue?vue&type=style&index=0&id=ff2fedbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2fedbc",
  null
  
)

export default component.exports